import { NgModule } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { DenseLayoutModule } from './layouts/dense/dense.module';

const layoutModules = [DenseLayoutModule];
@NgModule({
  imports: [LayoutComponent, ...layoutModules],
  exports: [LayoutComponent, ...layoutModules]
})
export class LayoutModule {}
